<template lang="pug">
div
  Accounts
  Activities
  PointShop
  Coupons
  .text-center.my-5
    Subscription
</template>

<script>
import Accounts from "@/components/Member/Accounts";
import Subscription from "@/components/Member/Subscription";
import Activities from "@/components/Member/Activities";
import PointShop from "@/components/Member/PointShop";
import Coupons from "@/components/Member/Coupons/index";
import { mapActions } from "vuex";
import _ from "underscore";

export default {
  components: { Accounts, Activities, PointShop, Coupons, Subscription },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions(["setMemberAccounts", "setBizAccounts"]),
    async load() {
      const user = this.$auth.user();
      if (!user) return;
      const params = { criteria: { user: user._id } };
      const { data } = await this.axios.post("/member/list", params);
      this.setMemberAccounts(data);
      this.loadBizAccounts(data);
    },
    async loadBizAccounts(members) {
      const ids = _.chain(members).pluck("biz").uniq().value();
      const params = {
        criteria: { _id: { $in: ids } },
        select: "name phones address url",
      };
      const bizs = await this.$api.biz.list(params);
      this.setBizAccounts(bizs);
    },
  },
};
</script>